import { useEffect, useState } from 'react';
import { AgxLabel, AgxRadio, AgxDatePicker } from '@urbanx/agx-ui-components';
import { SignboardRemoval, SignboardRemovalType } from './types';

interface SignboardRemovalProps {
  id: string;
  onValueChanged: (value: { id: string; value: SignboardRemoval }) => void;
  defaultValue?: SignboardRemoval;
  validate?: boolean;
}

const SignboardRemovalComponent = ({
  id,
  onValueChanged,
  defaultValue,
  validate,
}: SignboardRemovalProps) => {
  const [removalState, setRemovalState] = useState({
    removalType:
      defaultValue?.removalType ?? SignboardRemovalType.UponSettlement,
    specificDate: defaultValue?.specificDate,
  });

  const { removalType, specificDate } = removalState;

  useEffect(() => {
    onValueChanged({ id, value: removalState });
  }, [removalState]);

  return (
    <div className="agxRadio">
      <AgxLabel medium>When would you like the signboard removed?</AgxLabel>
      <div className="agxRadio-group">
        <AgxRadio
          id={`${id}-uponSettlement`}
          label="Upon settlement"
          onCheckChanged={() =>
            setRemovalState({
              ...removalState,
              removalType: SignboardRemovalType.UponSettlement,
            })
          }
          checked={removalType === SignboardRemovalType.UponSettlement}
        />
        <AgxRadio
          id={`${id}-onSpecificDate`}
          label="On specific date"
          onCheckChanged={() =>
            setRemovalState({
              ...removalState,
              removalType: SignboardRemovalType.OnSpecificDate,
            })
          }
          checked={removalType === SignboardRemovalType.OnSpecificDate}
          subContent={
            removalType === SignboardRemovalType.OnSpecificDate
              ? [
                  <AgxDatePicker
                    id={`${id}-specificDate`}
                    key={`${id}-specificDate`}
                    required
                    validate={validate}
                    onValueChanged={({ value }) => {
                      setRemovalState({
                        ...removalState,
                        specificDate: value,
                      });
                    }}
                    date
                    defaultValue={specificDate}
                    error={
                      validate && specificDate === ''
                        ? 'Enter a date'
                        : undefined
                    }
                  />,
                ]
              : undefined
          }
        />
        <AgxRadio
          id={`${id}-noSignboardInstalled`}
          label="No signboard installed"
          onCheckChanged={() =>
            setRemovalState({
              ...removalState,
              removalType: SignboardRemovalType.NoSignboardInstalled,
            })
          }
          checked={removalType === SignboardRemovalType.NoSignboardInstalled}
        />
      </div>
    </div>
  );
};

export default SignboardRemovalComponent;
